enum BatchStates {
    Open = 'open',
    Active = 'active',
    Completed = 'completed',
    Deleted = 'deleted',
    Proposal = 'proposal',
}

export { BatchStates };
